import {
  FETCH_CREATE_PROJECT_REQUEST,
  FETCH_CREATE_PROJECT_SUCCESS,
  FETCH_CREATE_PROJECT_FALUIRE,
} from './createProjectTypes'

const initialState = {
  loading: false,
  isCreateProjectSuccess: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREATE_PROJECT_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_CREATE_PROJECT_SUCCESS : return {
      ...state,
      isCreateProjectSuccess: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_CREATE_PROJECT_FALUIRE : return {
      ...state,
      loading: false,
      isCreateProjectSuccess: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
